import {QuoteWizardNavigationService} from './quoteWizardNavigation.service';
import {QuoteWizardStateService} from './quoteWizardState.service';

export class QuoteWizardDefaultViewController {
    public subject: any;

    public static $inject = ['$stateParams', 'quoteWizardStateService', 'quoteWizardNavigationService'];
    constructor(public parameters: any,
        public stateService: QuoteWizardStateService,
        protected navigationService: QuoteWizardNavigationService) {
        this.activate();
    }
    
    protected activate(): void {
        if (this.parameters && this.parameters.wizardParams) {
            this.subject = this.parameters.wizardParams.subject;
        }
    }

    public goNext() {
        this.navigationService.goNext();
    }

    public goBack() {
        this.navigationService.goBack();
    }
}